import React from 'react';
import { Reveal } from '../Reveal';
import { CountdownTimer } from '../CountdownTimer';
import { useLaunchExpired } from '../../hooks/useLaunchCountdown';
const SEATS_TAKEN = 68;
export function Urgency() {
  const isExpired = useLaunchExpired();
  return <section className="w-full px-4 py-10 sm:px-5 sm:py-14" aria-labelledby="urgency-title" data-id="element-297" data-mp="2blbdg38qrtx0">
      <Reveal className="mx-auto max-w-2xl rounded-3xl bg-lime px-4 py-8 text-center shadow-[0_18px_44px_rgba(122,30,60,0.25)] sm:px-8 sm:py-10" data-id="element-298" data-mp="26mgo0ig9r73x">
        <h2 id="urgency-title" className="mx-auto max-w-xl font-display text-2xl leading-tight text-ink sm:text-4xl" data-id="element-299" data-mp="2z8szdi5brxs2">
          {isExpired ? 'La promoción de lanzamiento finalizó' : 'Precio de lanzamiento — cierra en:'}
        </h2>

        {!isExpired && <div className="mt-6 flex justify-center" data-id="element-300" data-mp="2phf1tfwxp81k">
            <CountdownTimer data-id="element-301" data-mp="3mzf7f9fbxi22" />
          </div>}

        <p className="mx-auto mt-6 max-w-md text-sm font-extrabold text-gold-soft sm:text-base" data-id="element-302" data-mp="3i7x26969wvba">
          {isExpired ? 'El precio volvió a su valor habitual. Podés acceder a MegaPack Árabe PRO cuando quieras.' : 'Después sube $6.000 ARS. No vuelve.'}
        </p>

        {!isExpired && <div className="mt-7 rounded-2xl bg-black/15 px-4 py-5 sm:px-6" data-id="element-303" data-mp="b8etrxp7hel9">
            <p className="text-center text-xs font-extrabold text-ink sm:text-sm" data-id="element-304" data-mp="f9gu6huuzwot">
              <span className="mr-1.5 inline-block h-2 w-2 rounded-full bg-gold-soft align-middle" aria-hidden="true" data-id="element-305" data-mp="f7ds2zgfmd3q" />
              Cupos al precio de lanzamiento — <span className="text-gold-soft" data-id="element-306" data-mp="69tq1oaqwcs2">quedan pocos</span>
            </p>
            <div className="mt-3.5 h-3 w-full overflow-hidden rounded-full bg-black/25" role="progressbar" aria-valuenow={SEATS_TAKEN} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-307" data-mp="3oewz1k3u18xr">
              <div className="h-full rounded-full bg-gold-soft" style={{
            width: `${SEATS_TAKEN}%`
          }} data-id="element-308" data-mp="1qnlwl6ffbyi1" />
            </div>
            <p className="mt-2 text-right text-[11px] font-extrabold text-gold-soft sm:text-xs" data-id="element-309" data-mp="2zn56ummck3ss">
              {SEATS_TAKEN}% tomados
            </p>
          </div>}
      </Reveal>
    </section>;
}